import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { numberFilterOption } from "./filterOptionTypes";

export const LABEL = "Guests";
const GuestInput = ({ value = "", onChange }) => {
  const [inputValue, setInputValue] = useState(value);
  const validateInputValue = useCallback(
    (el) => {
      if (!el.target.value) {
        onChange();
        setInputValue("");
        return;
      }

      const parsed = parseInt(el.target.value, 10);
      if (isNaN(parsed)) {
        setInputValue("");
      } else if (parsed < 1) {
        onChange(1);
        setInputValue(1);
      } else {
        onChange(parsed);
        setInputValue(parsed);
      }
    },
    [setInputValue, onChange]
  );

  return (
    <input
      className="vs-input is-green"
      type="number"
      value={inputValue}
      onChange={validateInputValue}
      min="1"
      step="1"
      placeholder="Number of guests attending"
    />
  );
};

GuestInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default numberFilterOption({
  ga: "capacity",
  label: LABEL,
  title: "How many guests are coming?",
  name: "capacity",
  props: {
    green: true,
  },
  getValueLabel: (value) => value,
})(GuestInput);
